var ads = require('./ads');
var posts = require('./posts');
var util = require('./util');
var $ = require('jquery');

function getScroller(getter) {

  return function (baseUrl, maxScrolls, fetchedDocs, opt_data, opt_cb) {
    var endlessArticleLoader = $('.inertia-endless-loader');
    var endlessArticles = $('.inertia-endless-js').children().first();
    var fired = false;
    endlessArticleLoader.length && util.scrollWatcher(endlessArticleLoader, 0, function(eventType) {
      if (fired) {
        return;
      }

      if (fetchedDocs === maxScrolls) {
        endlessArticleLoader.remove();
      }

      if (eventType !== 'enter' || fetchedDocs > maxScrolls) {
        return;
      }

      opt_data = opt_data || {};
      $.extend(opt_data, {num: 15, paged: fetchedDocs});

      getter(baseUrl, opt_data, function(content) {
        var $content = $(content);
        $content.hide();
        endlessArticles.append($content);
        $content.fadeIn('slow');

        if (!$.trim(content)) {
          endlessArticleLoader.remove();
          fetchedDocs = maxScrolls;
        }
        opt_cb && opt_cb(content);
      });

      fetchedDocs++;
      fired = true;
      setTimeout(function() {
        fired = false;
      }, 500)
    });
  };
}

module.exports = {
  scrollerRecent: getScroller(posts.getRecent)
};
